import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ac-form-control" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "milestone" }, "Temas Türü", -1)
const _hoisted_3 = {
  key: 0,
  disabled: ""
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Lütfen bekleyiniz...", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["label"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ac-form-control" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "explanation" }, "Açıklama", -1)
const _hoisted_10 = {
  key: 0,
  class: "ac-form-control"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Dosyalar", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-gray-600 mb-4" }, "Teklif süreçleri ile ilgili dosyalarınızı yükleyebilirsiniz.", -1)
const _hoisted_13 = { class: "ac-button-row flex items-center justify-center" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["disabled"]

import type { AcMilestone } from '~/types/crm';
import type { RemoteFile } from '@/types/application';
import { ref, reactive, computed } from 'vue'
import { useGetDocs } from '@/mixins/modularFirebaseOperations'
import { formatUser } from '@/mixins/visualFormatters'
import { useStore } from 'vuex'
import firebaseOperations from '@/mixins/firebaseOperations'
import AccaDnDUpload from '@/components/reusable/accaDnDUpload.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'addMilestoneForm',
  emits: ["milestoneAdded", "cancelled"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const store = useStore()
const userProfile = computed(() => store.getters['user/userProfile'])

const { docs, isLoadingDocs } = useGetDocs("crm/milestones/list")

const organizedMileStoneTypes = computed(() => {
  
    let organizedTypes = {}

    docs.value.forEach((doc: AcMilestone) => {
        if(!organizedTypes[doc.category]){
            organizedTypes[doc.category] = []
        }
        organizedTypes[doc.category].push(doc)
    })

    // Sort the keys of the organizedTypes object alphabetically
    const sortedKeys = Object.keys(organizedTypes).sort()
    const sortedOrganizedTypes = {}
    sortedKeys.forEach((key) => {
        sortedOrganizedTypes[key] = organizedTypes[key]
    })
    organizedTypes = sortedOrganizedTypes

    return organizedTypes
    
})


const selectedMilestoneType = ref<Partial<AcMilestone> | undefined>(undefined)

const milestoneFields = reactive({
    explanation: "",
})

// File upload state
const uploadedFiles = ref<File[]>([])
const isUploading = ref(false)

// Check if selected milestone type is "Teklif Süreçleri"
const shouldShowFileUpload = computed(() => {
    return selectedMilestoneType.value?.category === "Teklif Süreçleri"
})

const handleFilesChanged = (files: File[]) => {
    uploadedFiles.value = files
}

const completeMileStone = computed(() => {

    // remove the user and the date from the selectedMilestoneType
    // eslint-disable-next-line
    const { user, date, ...rest } = selectedMilestoneType.value
    
    const finalMilestone: AcMilestone = {
        date: new Date(),
        user: formatUser(userProfile.value),
        explanation: milestoneFields.explanation,
        ...rest,
    }
    return finalMilestone
})

const handleSubmit = async () => {
    if (shouldShowFileUpload.value && uploadedFiles.value.length > 0) {
        isUploading.value = true
        try {
            // Upload files to storage
            const uploadedDocuments: RemoteFile[] = []
            
            for (const file of uploadedFiles.value) {
                const uploadedUrl = await firebaseOperations.methods.uploadSingleToStorage(file, 'crm/milestones/documents')
                uploadedDocuments.push({
                    url: uploadedUrl,
                    name: file.name,
                    type: file.type,
                })
            }
            
            // Create milestone with documents
            const milestoneWithDocuments = {
                ...completeMileStone.value,
                documents: uploadedDocuments
            }
            
            emits("milestoneAdded", milestoneWithDocuments)
        } catch (error) {
            alert(`Dosya yükleme sırasında bir hata oluştu: ${error}. Lütfen tekrar deneyiniz.`)
        } finally {
            isUploading.value = false
        }
    } else {
        emits("milestoneAdded", completeMileStone.value)
    }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_unref(isLoadingDocs))
        ? (_openBlock(), _createElementBlock("select", _hoisted_3, _hoisted_5))
        : _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 1,
            class: "py-3",
            required: "",
            id: "milestone",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMilestoneType).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizedMileStoneTypes.value, (items, categoryName) => {
              return (_openBlock(), _createElementBlock("optgroup", {
                key: categoryName,
                label: categoryName
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: item
                  }, _toDisplayString(item.title), 9, _hoisted_7))
                }), 128))
              ], 8, _hoisted_6))
            }), 128))
          ], 512)), [
            [_vModelSelect, selectedMilestoneType.value]
          ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Gerekli ek açıklamaları buradan girebilirsiniz.",
        id: "explanation",
        class: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((milestoneFields.explanation) = $event))
      }, "\n\n            ", 512), [
        [_vModelText, milestoneFields.explanation]
      ])
    ]),
    (shouldShowFileUpload.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createVNode(AccaDnDUpload, {
            "single-file": false,
            onFilesChanged: handleFilesChanged
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "submit",
        class: "ac-primary-button",
        onClick: handleSubmit,
        disabled: isUploading.value
      }, [
        (isUploading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Yükleniyor..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, "Gönder"))
      ], 8, _hoisted_14),
      _createElementVNode("button", {
        type: "button",
        class: "ac-secondary-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('cancelled'))),
        disabled: isUploading.value
      }, "İptal", 8, _hoisted_17)
    ])
  ], 32))
}
}

})